import { render, staticRenderFns } from "./html-editor.vue?vue&type=template&id=afa073c2&"
import script from "./html-editor.vue?vue&type=script&lang=js&"
export * from "./html-editor.vue?vue&type=script&lang=js&"
import style0 from "./html-editor.vue?vue&type=style&index=0&id=afa073c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports